// src/features/leases/pages/components/GanttListTestFixture.jsx
//
// DEV-ONLY test fixture. Renders PortfolioGantt with listView={true} and
// minimal seed leases so Playwright e2e tests can access the gantt-sort-th
// elements and verify :focus-visible CSS without navigating through the
// production UI (which uses LeasesListTable in list mode instead).
//
// Accessible at /?__e2e=gantt-list in development mode only.
// Never imported in production — see the import.meta.env.DEV guard in App.jsx.
//
// Lease design (today pinned to 2026-05-27 in both the component and the
// specs that use it):
//
//   e2e-days-short   — endDate 2026-08-25 → ~90 days remaining
//   e2e-days-medium  — endDate 2027-03-01 → ~278 days remaining
//   e2e-days-long    — endDate 2028-05-27 → ~731 days remaining
//   e2e-days-expired — status "expired"   → null sentinel (sorts last asc)
//
// The three active leases give a clear ascending/descending sort signal;
// the expired lease exercises the 99999 sentinel path in listSortComparator.

import React from "react";
import { PortfolioGantt } from "./PortfolioGantt.jsx";

// today pinned for deterministic day counts in e2e assertions.
const FIXTURE_TODAY = new Date("2026-05-27");

const SEED_LEASES = [
  {
    id: "e2e-days-short",
    locationId: "loc-e2e-short",
    city: "Short City",
    locationAlias: "90-day Office",
    region: "AMER",
    leaseType: "direct_lease",
    status: "active",
    startDate: "2022-01-01",
    endDate: "2026-08-25",
    totalCost: 100000,
    currency: "USD",
  },
  {
    id: "e2e-days-medium",
    locationId: "loc-e2e-medium",
    city: "Medium City",
    locationAlias: null,
    region: "EMEA",
    leaseType: "serviced_office",
    status: "active",
    startDate: "2023-03-01",
    endDate: "2027-03-01",
    totalCost: 250000,
    currency: "GBP",
  },
  {
    id: "e2e-days-long",
    locationId: "loc-e2e-long",
    city: "Long City",
    locationAlias: "Multi-Year HQ",
    region: "APAC",
    leaseType: "direct_lease",
    status: "active",
    startDate: "2021-06-01",
    endDate: "2028-05-27",
    totalCost: 800000,
    currency: "AUD",
  },
  {
    id: "e2e-days-expired",
    locationId: "loc-e2e-expired",
    city: "Expired City",
    locationAlias: null,
    region: "AMER",
    leaseType: "direct_lease",
    status: "expired",
    startDate: "2019-01-01",
    endDate: "2024-01-01",
    totalCost: 50000,
    currency: "USD",
  },
];

export function GanttListTestFixture() {
  return (
    <div
      data-testid="gantt-list-test-fixture"
      style={{ padding: 24, fontFamily: "sans-serif" }}
    >
      <PortfolioGantt
        leases={SEED_LEASES}
        today={FIXTURE_TODAY}
        listView={true}
      />
    </div>
  );
}
